<template>
  <div class="px-4 pb-4">
    <data-table :columns="columns" :rows="rows">
    </data-table>
  </div>
</template>

<script>
import DataTable from "@/components/data-table";

export default {
name: "user-permissions-table",
  components: {DataTable},
  data(){
    return{
      searchTerm: '',
      selected_permission: {},
      columns: [
        {
          field: 'name',
          label: 'Name'
        },
        {
          field: 'codename',
          label: 'Code Name'
        }
      ],
    }
  },
  props: {
    rows: {type: Array}
  },
}
</script>

<style scoped>

</style>
